import { BaseLog, BaseLogArgs } from '../BaseLog';
import { LEVEL } from '../LEVEL';

export function CashinLog({ message, data }: Partial<BaseLogArgs>) {
    return BaseLog({
        category: 'CASHIN',
        message,
        data: { ...data },
        level: LEVEL.INFO
    });
}
